import { render, staticRenderFns } from "./Ptlist.vue?vue&type=template&id=fe87bb90&"
import script from "./Ptlist.vue?vue&type=script&lang=js&"
export * from "./Ptlist.vue?vue&type=script&lang=js&"
import style0 from "./Ptlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports